import React, { useState, useEffect } from "react";
import Header from "./header/header";
import Footer from "./Footer";
import "./Webinars.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { Modal } from "react-bootstrap";
import { BsEmojiFrown } from "react-icons/bs";
import { baseUrl, GetToken } from "../App";

interface Webinar {
  companyEmail: string;
  companyPhone: string;
  image: string;
  webinarTitle: string;
  webinarPlatform: string;
  webinarDate: string;
  id: string;
  show: boolean;
  eventDate: string;
}

const Webinars: React.FC = () => {
  const [ready, setReady] = useState(false);
  const [pastWebinar, setPastWebinar] = useState(false);
  const [upcomingWebinar, setUpcomingWebinar] = useState(true);
  const [webinarData, setWebinarData] = useState<{
    upcoming: Webinar[];
    past: Webinar[];
  }>({ upcoming: [], past: [] });
  const showPastWebinar = () => {
    setPastWebinar(true);
    setUpcomingWebinar(false);
  };

  const showUpcomingWebinar = () => {
    setPastWebinar(false);
    setUpcomingWebinar(true);
  };

  useEffect(() => {
    const fetchWebinars = async () => {
      try {
        const idToken = await GetToken();
        const webinarresponse = await axios.get(
          `${baseUrl}/webinar`,
          {
            headers: {
              Authorization: `Bearer ${idToken}`,
            },
          }
        );

        const updatedData = webinarresponse.data.map((item: any) => {
          let eventDate = "";
          if (item.eventDate) {
            if (typeof item.eventDate === "string") {
              eventDate = item.eventDate;
            } else if (item.eventDate._seconds) {
              eventDate = new Date(
                item.eventDate._seconds * 1000
              ).toISOString();
            }
          }
          return { ...item, eventDate };
        });

        const sortedData = updatedData.sort((a: any, b: any) => {
          const dateA = new Date(a.eventDate).getTime();
          const dateB = new Date(b.eventDate).getTime();
          return dateB - dateA;
        });

        const currentDate = new Date();
        const upcoming: Webinar[] = [];
        const past: Webinar[] = [];

        console.log("sortedData", sortedData)
        sortedData.forEach((webinar: Webinar) => {
          if (!webinar.show) {
            return;
          }
          const webinarDate = new Date(webinar.eventDate);
          if (webinarDate >= currentDate) {
            upcoming.push(webinar);
          } else {
            past.push(webinar);
          }
        });

        setWebinarData({
          upcoming: upcoming,
          past: past,
        });
        setReady(true);
      } catch (error) {
        console.error("Error fetching webinars", error);
        setShowModal(true);
        setModalContent(getErrorMessage(error));
      }
    };

    fetchWebinars();
  }, []);

  const [showModal, setShowModal] = React.useState(false);
  const [modalContent, setModalContent] = React.useState("");

  // Function to get error message based on error type
  const getErrorMessage = (error: any) => {
    if (!error.response) {
      return "Network Error: Unable to connect to the server. Please check your internet connection.";
    }
    const statusCode = error.response.status;
    switch (statusCode) {
      case 500:
        return "Oops, there is a slight issue with our server, please refresh or try again in a moment.";
      case 400:
        return "Sorry, our server cannot process your input. Please confirm your input.";
      case 403:
        return "You do not have permission to access this resource.";
      case 404:
        return "Your requested resource could not be found on the server.";
      default:
        return `Error ${statusCode}: An error occurred. Please try again later.`;
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setModalContent(""); // Reset modal content
  };

  let navigate = useNavigate();

  const getWebinarForm = (webinarTitle: string, id:string) => {
    const slug = webinarTitle.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    console.log(id)
    navigate("/register/" + slug, { state: { Id: id } });
  };

  return (
    <div>
      <Modal show={showModal} onHide={handleModalClose} centered={true}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex justify-center items-center align-center text-center p-2">
            <BsEmojiFrown
              size={50}
              color="#047E35"
              className="flex justify-center items-center "
            />
          </div>

          <div>{modalContent}</div>
        </Modal.Body>
      </Modal>
      {ready ? (
        <>
          <Header />
          <div className="container" style={{ marginTop: "25px" }}>
            <div className="row">
              <div className="col-md-3"></div>
              <div className="col-md-6">
                <div className="row text-center">
                  <div className="col-md-6">
                    <div
                      className={upcomingWebinar ? "showtab" : "hidetab"}
                      onClick={showUpcomingWebinar}
                    >
                      <h5>Upcoming Events</h5>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div
                      className={pastWebinar ? "showtab" : "hidetab"}
                      onClick={showPastWebinar}
                    >
                      <h5>Past Events</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3"></div>
            </div>
          </div>
          {webinarData.upcoming.length > 0 ? (
            <>
              {upcomingWebinar ? (
                <>
                  <div className="container" style={{ marginTop: "20px" }}>
                    <hr />
                    {webinarData.upcoming.map((item: any) => (
                      <div key={item.id} style={{ marginBottom: "20px" }}>
                        <div className="row">
                          <div className="col-md-4">
                            <div
                              style={{
                                backgroundColor: "#225c3f",
                                color: "#ffffff",
                                padding: "43px",
                                textAlign: "center",
                              }}
                            >
                              <h3>{item.webinarDate}</h3>
                              <h4>{item.eventTime}</h4>
                              <button
                                className="btn btn-success"
                                onClick={() => getWebinarForm(item?.webinarTitle, item.id)}
                              >
                                Register Now
                              </button>
                            </div>
                          </div>
                          <div className="col-md-8">
                            <div
                              style={{
                                border: "1px solid #000000",
                                padding: "50px",
                              }}
                            >
                              <img
                                src={item.image}
                                alt="webimg"
                                style={{ width: "100%", marginBottom: "20px" }}
                              />
                              <h4>{item.webinarTitle}</h4>
                              <p>Event platform: {item.webinarPlatform}</p>
                              <p>Reachout to Us at: {item.companyEmail}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <></>
              )}
            </>
          ) : (
            <>
              {upcomingWebinar && (
                <div className="container" style={{ marginTop: "20px" }}>
                  <hr />
                  <p>
                    {" "}
                    Anticipate our coming events on this page. Check out our
                    previous events at the 'Past Events' section
                  </p>
                </div>
              )}
            </>
          )}

          {pastWebinar ? (
            <>
              <div className="container" style={{ marginTop: "20px" }}>
                {webinarData.past.map((item: any) => (
                  <div key={item.id} style={{ marginBottom: "20px" }}>
                    <hr />
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          style={{
                            backgroundColor: "#225c3f",
                            color: "#ffffff",
                            padding: "43px",
                            textAlign: "center",
                          }}
                        >
                          <h3>{item.webinarDate}</h3>
                          <h4>{item.eventTime}</h4>
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div
                          style={{
                            border: "1px solid #000000",
                            padding: "50px",
                          }}
                        >
                          <img
                            src={item.image}
                            alt="webimg"
                            style={{ width: "100%", marginBottom: "20px" }}
                          />
                          <h4>{item.webinarTitle}</h4>
                          <p>Event platform: {item.webinarPlatform}</p>
                          <p>Reachout to Us at: {item.companyEmail}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <></>
          )}

          <br />
          <br />

          <Footer />
        </>
      ) : (
        <>
          <div>
            {/* <Audio
                        height="80"
                        width="80"
                        // radius="9"
                        color="green"
                        ariaLabel="loading"
                        wrapperStyle={{alignItems: "center", justifyContent: "center",verticalAlign: "middle", margin: "auto", position: "absolute",
                        top: "0", left: "0", bottom: "0", right: "0"}}
                        // wrapperClass
                        /> */}

            <div className="academystyle">
              <img src="../../images/doyenifyAcademy.png" alt="doy academy" />
              <ClipLoader size={25} color="#047E35" />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Webinars;
